import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import _regeneratorRuntime from "@babel/runtime/regenerator";
import constants from "../../constants";
import http from "../http";
var SCHOOLS_ENDPOINT = "".concat(constants.API_URL, "/schools");
var SCHOOLS_ENDPOINT_V1 = "".concat(constants.API_URL_V1, "/schools");

function adminsUrl(id) {
  return "".concat(SCHOOLS_ENDPOINT, "/").concat(id, "/admins");
}

function adminUrl(schoolId, id) {
  return "".concat(adminsUrl(schoolId), "/").concat(id);
}

function schoolUrl(id) {
  return "".concat(SCHOOLS_ENDPOINT, "/").concat(id);
}

function getSchools(_x) {
  return _getSchools.apply(this, arguments);
}

function _getSchools() {
  _getSchools = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee28(_ref) {
    var params, response;
    return _regeneratorRuntime.wrap(function _callee28$(_context28) {
      while (1) {
        switch (_context28.prev = _context28.next) {
          case 0:
            params = _ref.params;
            _context28.next = 3;
            return http.get("".concat(SCHOOLS_ENDPOINT), {
              params: params
            });

          case 3:
            response = _context28.sent;
            return _context28.abrupt("return", response);

          case 5:
          case "end":
            return _context28.stop();
        }
      }
    }, _callee28);
  }));
  return _getSchools.apply(this, arguments);
}

function getSchool(_x2) {
  return _getSchool.apply(this, arguments);
}

function _getSchool() {
  _getSchool = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee29(itemId) {
    var response;
    return _regeneratorRuntime.wrap(function _callee29$(_context29) {
      while (1) {
        switch (_context29.prev = _context29.next) {
          case 0:
            _context29.next = 2;
            return http.get("".concat(SCHOOLS_ENDPOINT, "/").concat(itemId));

          case 2:
            response = _context29.sent;
            return _context29.abrupt("return", response);

          case 4:
          case "end":
            return _context29.stop();
        }
      }
    }, _callee29);
  }));
  return _getSchool.apply(this, arguments);
}

function createSchool(_x3) {
  return _createSchool.apply(this, arguments);
}

function _createSchool() {
  _createSchool = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee30(item) {
    var response;
    return _regeneratorRuntime.wrap(function _callee30$(_context30) {
      while (1) {
        switch (_context30.prev = _context30.next) {
          case 0:
            _context30.next = 2;
            return http.post(SCHOOLS_ENDPOINT, item);

          case 2:
            response = _context30.sent;
            return _context30.abrupt("return", response);

          case 4:
          case "end":
            return _context30.stop();
        }
      }
    }, _callee30);
  }));
  return _createSchool.apply(this, arguments);
}

function updateSchool(_x4) {
  return _updateSchool.apply(this, arguments);
}

function _updateSchool() {
  _updateSchool = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee31(_ref2) {
    var schoolId, data, response;
    return _regeneratorRuntime.wrap(function _callee31$(_context31) {
      while (1) {
        switch (_context31.prev = _context31.next) {
          case 0:
            schoolId = _ref2.schoolId, data = _ref2.data;
            _context31.next = 3;
            return http.patch("".concat(SCHOOLS_ENDPOINT, "/").concat(schoolId), data);

          case 3:
            response = _context31.sent;
            return _context31.abrupt("return", response);

          case 5:
          case "end":
            return _context31.stop();
        }
      }
    }, _callee31);
  }));
  return _updateSchool.apply(this, arguments);
}

function deleteSchool(_x5) {
  return _deleteSchool.apply(this, arguments);
}

function _deleteSchool() {
  _deleteSchool = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee32(itemId) {
    var response;
    return _regeneratorRuntime.wrap(function _callee32$(_context32) {
      while (1) {
        switch (_context32.prev = _context32.next) {
          case 0:
            _context32.next = 2;
            return http["delete"]("".concat(SCHOOLS_ENDPOINT, "/").concat(itemId));

          case 2:
            response = _context32.sent;
            return _context32.abrupt("return", response);

          case 4:
          case "end":
            return _context32.stop();
        }
      }
    }, _callee32);
  }));
  return _deleteSchool.apply(this, arguments);
}

function deactivateSchool(_x6) {
  return _deactivateSchool.apply(this, arguments);
}

function _deactivateSchool() {
  _deactivateSchool = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee33(itemId) {
    var response;
    return _regeneratorRuntime.wrap(function _callee33$(_context33) {
      while (1) {
        switch (_context33.prev = _context33.next) {
          case 0:
            _context33.next = 2;
            return http.post("".concat("".concat(SCHOOLS_ENDPOINT, "/").concat(itemId), "/users/deactivate"));

          case 2:
            response = _context33.sent;
            return _context33.abrupt("return", response);

          case 4:
          case "end":
            return _context33.stop();
        }
      }
    }, _callee33);
  }));
  return _deactivateSchool.apply(this, arguments);
}

function getSchoolSystems() {
  return _getSchoolSystems.apply(this, arguments);
}

function _getSchoolSystems() {
  _getSchoolSystems = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee34() {
    var response;
    return _regeneratorRuntime.wrap(function _callee34$(_context34) {
      while (1) {
        switch (_context34.prev = _context34.next) {
          case 0:
            _context34.next = 2;
            return http.get("".concat(SCHOOLS_ENDPOINT, "/system-values"));

          case 2:
            response = _context34.sent;
            return _context34.abrupt("return", response);

          case 4:
          case "end":
            return _context34.stop();
        }
      }
    }, _callee34);
  }));
  return _getSchoolSystems.apply(this, arguments);
}

function getSchoolCourseTemplates(_x7) {
  return _getSchoolCourseTemplates.apply(this, arguments);
}

function _getSchoolCourseTemplates() {
  _getSchoolCourseTemplates = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee35(_ref3) {
    var schoolId, params, response;
    return _regeneratorRuntime.wrap(function _callee35$(_context35) {
      while (1) {
        switch (_context35.prev = _context35.next) {
          case 0:
            schoolId = _ref3.schoolId, params = _ref3.params;
            _context35.next = 3;
            return http.get("".concat(SCHOOLS_ENDPOINT, "/").concat(schoolId, "/course-templates"), {
              params: params
            });

          case 3:
            response = _context35.sent;
            return _context35.abrupt("return", response);

          case 5:
          case "end":
            return _context35.stop();
        }
      }
    }, _callee35);
  }));
  return _getSchoolCourseTemplates.apply(this, arguments);
}

function getSchoolGradebookSystems(_x8) {
  return _getSchoolGradebookSystems.apply(this, arguments);
} // Admins


function _getSchoolGradebookSystems() {
  _getSchoolGradebookSystems = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee36(_ref4) {
    var schoolId, _yield$http$get, data;

    return _regeneratorRuntime.wrap(function _callee36$(_context36) {
      while (1) {
        switch (_context36.prev = _context36.next) {
          case 0:
            schoolId = _ref4.schoolId;
            _context36.next = 3;
            return http.get("".concat(SCHOOLS_ENDPOINT, "/").concat(schoolId, "/gradebook-systems"));

          case 3:
            _yield$http$get = _context36.sent;
            data = _yield$http$get.data;
            return _context36.abrupt("return", data);

          case 6:
          case "end":
            return _context36.stop();
        }
      }
    }, _callee36);
  }));
  return _getSchoolGradebookSystems.apply(this, arguments);
}

function createAdmin(_x9, _x10) {
  return _createAdmin.apply(this, arguments);
}

function _createAdmin() {
  _createAdmin = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee37(schoolId, item) {
    var response;
    return _regeneratorRuntime.wrap(function _callee37$(_context37) {
      while (1) {
        switch (_context37.prev = _context37.next) {
          case 0:
            _context37.next = 2;
            return http.post(adminsUrl(schoolId), item);

          case 2:
            response = _context37.sent;
            return _context37.abrupt("return", response);

          case 4:
          case "end":
            return _context37.stop();
        }
      }
    }, _callee37);
  }));
  return _createAdmin.apply(this, arguments);
}

function createPrincipal(_x11) {
  return _createPrincipal.apply(this, arguments);
}

function _createPrincipal() {
  _createPrincipal = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee38(_ref5) {
    var schoolId, data, response;
    return _regeneratorRuntime.wrap(function _callee38$(_context38) {
      while (1) {
        switch (_context38.prev = _context38.next) {
          case 0:
            schoolId = _ref5.schoolId, data = _ref5.data;
            _context38.next = 3;
            return http.post("".concat(schoolUrl(schoolId), "/principals"), _objectSpread({}, data));

          case 3:
            response = _context38.sent;
            return _context38.abrupt("return", response);

          case 5:
          case "end":
            return _context38.stop();
        }
      }
    }, _callee38);
  }));
  return _createPrincipal.apply(this, arguments);
}

function createHod(_x12) {
  return _createHod.apply(this, arguments);
}

function _createHod() {
  _createHod = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee39(_ref6) {
    var schoolId, data, response;
    return _regeneratorRuntime.wrap(function _callee39$(_context39) {
      while (1) {
        switch (_context39.prev = _context39.next) {
          case 0:
            schoolId = _ref6.schoolId, data = _ref6.data;
            _context39.next = 3;
            return http.post("".concat(schoolUrl(schoolId), "/hods"), data);

          case 3:
            response = _context39.sent;
            return _context39.abrupt("return", response);

          case 5:
          case "end":
            return _context39.stop();
        }
      }
    }, _callee39);
  }));
  return _createHod.apply(this, arguments);
}

function createParent(_x13) {
  return _createParent.apply(this, arguments);
}

function _createParent() {
  _createParent = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee40(_ref7) {
    var schoolId, data, response;
    return _regeneratorRuntime.wrap(function _callee40$(_context40) {
      while (1) {
        switch (_context40.prev = _context40.next) {
          case 0:
            schoolId = _ref7.schoolId, data = _ref7.data;
            _context40.next = 3;
            return http.post("".concat(schoolUrl(schoolId), "/parents"), data);

          case 3:
            response = _context40.sent;
            return _context40.abrupt("return", response);

          case 5:
          case "end":
            return _context40.stop();
        }
      }
    }, _callee40);
  }));
  return _createParent.apply(this, arguments);
}

function deleteAdmin(_x14, _x15) {
  return _deleteAdmin.apply(this, arguments);
} // Announcements


function _deleteAdmin() {
  _deleteAdmin = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee41(schoolId, itemId) {
    var response;
    return _regeneratorRuntime.wrap(function _callee41$(_context41) {
      while (1) {
        switch (_context41.prev = _context41.next) {
          case 0:
            _context41.next = 2;
            return http["delete"](adminUrl(schoolId, itemId));

          case 2:
            response = _context41.sent;
            return _context41.abrupt("return", response);

          case 4:
          case "end":
            return _context41.stop();
        }
      }
    }, _callee41);
  }));
  return _deleteAdmin.apply(this, arguments);
}

function createAnnouncement(_x16, _x17, _x18) {
  return _createAnnouncement.apply(this, arguments);
}

function _createAnnouncement() {
  _createAnnouncement = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee42(schoolId, announcement, onUploadProgress) {
    var response;
    return _regeneratorRuntime.wrap(function _callee42$(_context42) {
      while (1) {
        switch (_context42.prev = _context42.next) {
          case 0:
            _context42.next = 2;
            return http.post("".concat(SCHOOLS_ENDPOINT, "/").concat(schoolId, "/announcements"), announcement, {
              onUploadProgress: onUploadProgress
            });

          case 2:
            response = _context42.sent;
            return _context42.abrupt("return", response);

          case 4:
          case "end":
            return _context42.stop();
        }
      }
    }, _callee42);
  }));
  return _createAnnouncement.apply(this, arguments);
}

function listSchoolAnnouncements(_x19) {
  return _listSchoolAnnouncements.apply(this, arguments);
} // Questions


function _listSchoolAnnouncements() {
  _listSchoolAnnouncements = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee43(_ref8) {
    var schoolId, params, _yield$http$get2, data;

    return _regeneratorRuntime.wrap(function _callee43$(_context43) {
      while (1) {
        switch (_context43.prev = _context43.next) {
          case 0:
            schoolId = _ref8.schoolId, params = _ref8.params;
            _context43.next = 3;
            return http.get("".concat(SCHOOLS_ENDPOINT, "/").concat(schoolId, "/announcements"), {
              params: params
            });

          case 3:
            _yield$http$get2 = _context43.sent;
            data = _yield$http$get2.data;
            return _context43.abrupt("return", data);

          case 6:
          case "end":
            return _context43.stop();
        }
      }
    }, _callee43);
  }));
  return _listSchoolAnnouncements.apply(this, arguments);
}

function getSchoolQuestions(_x20) {
  return _getSchoolQuestions.apply(this, arguments);
} // Tags


function _getSchoolQuestions() {
  _getSchoolQuestions = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee44(_ref9) {
    var schoolId, params, response;
    return _regeneratorRuntime.wrap(function _callee44$(_context44) {
      while (1) {
        switch (_context44.prev = _context44.next) {
          case 0:
            schoolId = _ref9.schoolId, params = _ref9.params;
            _context44.next = 3;
            return http.get("".concat(SCHOOLS_ENDPOINT, "/").concat(schoolId, "/questions"), {
              params: params
            });

          case 3:
            response = _context44.sent;
            return _context44.abrupt("return", response);

          case 5:
          case "end":
            return _context44.stop();
        }
      }
    }, _callee44);
  }));
  return _getSchoolQuestions.apply(this, arguments);
}

function getSchoolTags(_x21) {
  return _getSchoolTags.apply(this, arguments);
}

function _getSchoolTags() {
  _getSchoolTags = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee45(_ref10) {
    var schoolId, params, response;
    return _regeneratorRuntime.wrap(function _callee45$(_context45) {
      while (1) {
        switch (_context45.prev = _context45.next) {
          case 0:
            schoolId = _ref10.schoolId, params = _ref10.params;
            _context45.next = 3;
            return http.get("".concat(SCHOOLS_ENDPOINT_V1, "/").concat(schoolId, "/tags"), {
              params: params
            });

          case 3:
            response = _context45.sent;
            return _context45.abrupt("return", response);

          case 5:
          case "end":
            return _context45.stop();
        }
      }
    }, _callee45);
  }));
  return _getSchoolTags.apply(this, arguments);
}

function createTag(_x22) {
  return _createTag.apply(this, arguments);
} // Semesters


function _createTag() {
  _createTag = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee46(_ref11) {
    var schoolId, data, response;
    return _regeneratorRuntime.wrap(function _callee46$(_context46) {
      while (1) {
        switch (_context46.prev = _context46.next) {
          case 0:
            schoolId = _ref11.schoolId, data = _ref11.data;
            _context46.next = 3;
            return http.post("".concat(SCHOOLS_ENDPOINT_V1, "/").concat(schoolId, "/tags"), data);

          case 3:
            response = _context46.sent;
            return _context46.abrupt("return", response);

          case 5:
          case "end":
            return _context46.stop();
        }
      }
    }, _callee46);
  }));
  return _createTag.apply(this, arguments);
}

function getSchoolSemesters(_x23) {
  return _getSchoolSemesters.apply(this, arguments);
}

function _getSchoolSemesters() {
  _getSchoolSemesters = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee47(_ref12) {
    var schoolId, params, response;
    return _regeneratorRuntime.wrap(function _callee47$(_context47) {
      while (1) {
        switch (_context47.prev = _context47.next) {
          case 0:
            schoolId = _ref12.schoolId, params = _ref12.params;
            _context47.next = 3;
            return http.get("".concat(constants.API_URL, "/schools/").concat(schoolId, "/semesters"), {
              params: params
            });

          case 3:
            response = _context47.sent;
            return _context47.abrupt("return", response);

          case 5:
          case "end":
            return _context47.stop();
        }
      }
    }, _callee47);
  }));
  return _getSchoolSemesters.apply(this, arguments);
}

function getActiveSemester(_x24) {
  return _getActiveSemester.apply(this, arguments);
}

function _getActiveSemester() {
  _getActiveSemester = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee48(_ref13) {
    var schoolId, response;
    return _regeneratorRuntime.wrap(function _callee48$(_context48) {
      while (1) {
        switch (_context48.prev = _context48.next) {
          case 0:
            schoolId = _ref13.schoolId;
            _context48.next = 3;
            return http.get("".concat(constants.API_URL, "/schools/").concat(schoolId, "/semesters/active"));

          case 3:
            response = _context48.sent;
            return _context48.abrupt("return", response);

          case 5:
          case "end":
            return _context48.stop();
        }
      }
    }, _callee48);
  }));
  return _getActiveSemester.apply(this, arguments);
}

function getSchoolParentsV1(_x25) {
  return _getSchoolParentsV.apply(this, arguments);
}

function _getSchoolParentsV() {
  _getSchoolParentsV = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee49(_ref14) {
    var schoolId, params, response;
    return _regeneratorRuntime.wrap(function _callee49$(_context49) {
      while (1) {
        switch (_context49.prev = _context49.next) {
          case 0:
            schoolId = _ref14.schoolId, params = _ref14.params;
            _context49.next = 3;
            return http.get("".concat(SCHOOLS_ENDPOINT_V1, "/").concat(schoolId, "/parents"), {
              params: params
            });

          case 3:
            response = _context49.sent;
            return _context49.abrupt("return", response);

          case 5:
          case "end":
            return _context49.stop();
        }
      }
    }, _callee49);
  }));
  return _getSchoolParentsV.apply(this, arguments);
}

function getSchoolPrincipalsV2(_x26) {
  return _getSchoolPrincipalsV.apply(this, arguments);
}

function _getSchoolPrincipalsV() {
  _getSchoolPrincipalsV = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee50(_ref15) {
    var schoolId, params, response;
    return _regeneratorRuntime.wrap(function _callee50$(_context50) {
      while (1) {
        switch (_context50.prev = _context50.next) {
          case 0:
            schoolId = _ref15.schoolId, params = _ref15.params;
            _context50.next = 3;
            return http.get("".concat(constants.API_URL_V2, "/schools/").concat(schoolId, "/principals"), {
              params: params
            });

          case 3:
            response = _context50.sent;
            return _context50.abrupt("return", response);

          case 5:
          case "end":
            return _context50.stop();
        }
      }
    }, _callee50);
  }));
  return _getSchoolPrincipalsV.apply(this, arguments);
}

function getSchoolHodsV2(_x27) {
  return _getSchoolHodsV.apply(this, arguments);
}

function _getSchoolHodsV() {
  _getSchoolHodsV = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee51(_ref16) {
    var schoolId, params, response;
    return _regeneratorRuntime.wrap(function _callee51$(_context51) {
      while (1) {
        switch (_context51.prev = _context51.next) {
          case 0:
            schoolId = _ref16.schoolId, params = _ref16.params;
            _context51.next = 3;
            return http.get("".concat(constants.API_URL_V2, "/schools/").concat(schoolId, "/hods"), {
              params: params
            });

          case 3:
            response = _context51.sent;
            return _context51.abrupt("return", response);

          case 5:
          case "end":
            return _context51.stop();
        }
      }
    }, _callee51);
  }));
  return _getSchoolHodsV.apply(this, arguments);
}

function getSchoolTeachersV1(_x28) {
  return _getSchoolTeachersV.apply(this, arguments);
}

function _getSchoolTeachersV() {
  _getSchoolTeachersV = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee52(_ref17) {
    var schoolId, params, response;
    return _regeneratorRuntime.wrap(function _callee52$(_context52) {
      while (1) {
        switch (_context52.prev = _context52.next) {
          case 0:
            schoolId = _ref17.schoolId, params = _ref17.params;
            _context52.next = 3;
            return http.get("".concat(SCHOOLS_ENDPOINT_V1, "/").concat(schoolId, "/teachers"), {
              params: params
            });

          case 3:
            response = _context52.sent;
            return _context52.abrupt("return", response);

          case 5:
          case "end":
            return _context52.stop();
        }
      }
    }, _callee52);
  }));
  return _getSchoolTeachersV.apply(this, arguments);
}

function createTeacher(_x29) {
  return _createTeacher.apply(this, arguments);
}

function _createTeacher() {
  _createTeacher = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee53(_ref18) {
    var schoolId, data, response;
    return _regeneratorRuntime.wrap(function _callee53$(_context53) {
      while (1) {
        switch (_context53.prev = _context53.next) {
          case 0:
            schoolId = _ref18.schoolId, data = _ref18.data;
            _context53.next = 3;
            return http.post("".concat(schoolUrl(schoolId), "/teachers"), data);

          case 3:
            response = _context53.sent;
            return _context53.abrupt("return", response);

          case 5:
          case "end":
            return _context53.stop();
        }
      }
    }, _callee53);
  }));
  return _createTeacher.apply(this, arguments);
}

function importTeachers(_x30) {
  return _importTeachers.apply(this, arguments);
}

function _importTeachers() {
  _importTeachers = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee54(_ref19) {
    var schoolId, data, onUploadProgress, response;
    return _regeneratorRuntime.wrap(function _callee54$(_context54) {
      while (1) {
        switch (_context54.prev = _context54.next) {
          case 0:
            schoolId = _ref19.schoolId, data = _ref19.data, onUploadProgress = _ref19.onUploadProgress;
            _context54.next = 3;
            return http.post("".concat(schoolUrl(schoolId), "/teachers/import"), data, // sent to axios for showing uploadingProgress
            {
              onUploadProgress: onUploadProgress
            });

          case 3:
            response = _context54.sent;
            return _context54.abrupt("return", response);

          case 5:
          case "end":
            return _context54.stop();
        }
      }
    }, _callee54);
  }));
  return _importTeachers.apply(this, arguments);
}

function exportTeachers(_x31) {
  return _exportTeachers.apply(this, arguments);
}

function _exportTeachers() {
  _exportTeachers = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee55(_ref20) {
    var schoolId, response;
    return _regeneratorRuntime.wrap(function _callee55$(_context55) {
      while (1) {
        switch (_context55.prev = _context55.next) {
          case 0:
            schoolId = _ref20.schoolId;
            _context55.next = 3;
            return http.get("".concat(schoolUrl(schoolId), "/teachers/csv"));

          case 3:
            response = _context55.sent;
            return _context55.abrupt("return", response);

          case 5:
          case "end":
            return _context55.stop();
        }
      }
    }, _callee55);
  }));
  return _exportTeachers.apply(this, arguments);
}

function exportScores(_x32) {
  return _exportScores.apply(this, arguments);
}

function _exportScores() {
  _exportScores = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee56(_ref21) {
    var academicYearId, response;
    return _regeneratorRuntime.wrap(function _callee56$(_context56) {
      while (1) {
        switch (_context56.prev = _context56.next) {
          case 0:
            academicYearId = _ref21.academicYearId;
            _context56.next = 3;
            return http.get("".concat(constants.API_URL, "/academic-years/").concat(academicYearId, "/teachers/score-csv"));

          case 3:
            response = _context56.sent;
            return _context56.abrupt("return", response);

          case 5:
          case "end":
            return _context56.stop();
        }
      }
    }, _callee56);
  }));
  return _exportScores.apply(this, arguments);
}

function getSchoolStudentsV1(_x33) {
  return _getSchoolStudentsV.apply(this, arguments);
}

function _getSchoolStudentsV() {
  _getSchoolStudentsV = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee57(_ref22) {
    var schoolId, params, response;
    return _regeneratorRuntime.wrap(function _callee57$(_context57) {
      while (1) {
        switch (_context57.prev = _context57.next) {
          case 0:
            schoolId = _ref22.schoolId, params = _ref22.params;
            _context57.next = 3;
            return http.get("".concat(SCHOOLS_ENDPOINT_V1, "/").concat(schoolId, "/students"), {
              params: params
            });

          case 3:
            response = _context57.sent;
            return _context57.abrupt("return", response);

          case 5:
          case "end":
            return _context57.stop();
        }
      }
    }, _callee57);
  }));
  return _getSchoolStudentsV.apply(this, arguments);
}

function createStudent(_x34) {
  return _createStudent.apply(this, arguments);
}

function _createStudent() {
  _createStudent = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee58(_ref23) {
    var schoolId, data, response;
    return _regeneratorRuntime.wrap(function _callee58$(_context58) {
      while (1) {
        switch (_context58.prev = _context58.next) {
          case 0:
            schoolId = _ref23.schoolId, data = _ref23.data;
            _context58.next = 3;
            return http.post("".concat(schoolUrl(schoolId), "/students"), data);

          case 3:
            response = _context58.sent;
            return _context58.abrupt("return", response);

          case 5:
          case "end":
            return _context58.stop();
        }
      }
    }, _callee58);
  }));
  return _createStudent.apply(this, arguments);
}

function importPerformanceComments(_x35) {
  return _importPerformanceComments.apply(this, arguments);
}

function _importPerformanceComments() {
  _importPerformanceComments = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee59(_ref24) {
    var schoolId, data, onUploadProgress, response;
    return _regeneratorRuntime.wrap(function _callee59$(_context59) {
      while (1) {
        switch (_context59.prev = _context59.next) {
          case 0:
            schoolId = _ref24.schoolId, data = _ref24.data, onUploadProgress = _ref24.onUploadProgress;
            _context59.next = 3;
            return http.post("".concat(schoolUrl(schoolId), "/students/import/performance-comments"), data, {
              onUploadProgress: onUploadProgress
            });

          case 3:
            response = _context59.sent;
            return _context59.abrupt("return", response);

          case 5:
          case "end":
            return _context59.stop();
        }
      }
    }, _callee59);
  }));
  return _importPerformanceComments.apply(this, arguments);
}

function importParents(_x36) {
  return _importParents.apply(this, arguments);
}

function _importParents() {
  _importParents = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee60(_ref25) {
    var schoolId, data, onUploadProgress, response;
    return _regeneratorRuntime.wrap(function _callee60$(_context60) {
      while (1) {
        switch (_context60.prev = _context60.next) {
          case 0:
            schoolId = _ref25.schoolId, data = _ref25.data, onUploadProgress = _ref25.onUploadProgress;
            _context60.next = 3;
            return http.post("".concat(schoolUrl(schoolId), "/parents/import"), data, {
              onUploadProgress: onUploadProgress
            });

          case 3:
            response = _context60.sent;
            return _context60.abrupt("return", response);

          case 5:
          case "end":
            return _context60.stop();
        }
      }
    }, _callee60);
  }));
  return _importParents.apply(this, arguments);
}

function exportPerformanceComments(_x37) {
  return _exportPerformanceComments.apply(this, arguments);
}

function _exportPerformanceComments() {
  _exportPerformanceComments = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee61(_ref26) {
    var schoolId, response;
    return _regeneratorRuntime.wrap(function _callee61$(_context61) {
      while (1) {
        switch (_context61.prev = _context61.next) {
          case 0:
            schoolId = _ref26.schoolId;
            _context61.next = 3;
            return http.get("".concat(schoolUrl(schoolId), "/students/csv/performance-comments"));

          case 3:
            response = _context61.sent;
            return _context61.abrupt("return", response);

          case 5:
          case "end":
            return _context61.stop();
        }
      }
    }, _callee61);
  }));
  return _exportPerformanceComments.apply(this, arguments);
}

function exportParents(_x38) {
  return _exportParents.apply(this, arguments);
}

function _exportParents() {
  _exportParents = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee62(_ref27) {
    var schoolId, response;
    return _regeneratorRuntime.wrap(function _callee62$(_context62) {
      while (1) {
        switch (_context62.prev = _context62.next) {
          case 0:
            schoolId = _ref27.schoolId;
            _context62.next = 3;
            return http.get("".concat(schoolUrl(schoolId), "/parents/csv"));

          case 3:
            response = _context62.sent;
            return _context62.abrupt("return", response);

          case 5:
          case "end":
            return _context62.stop();
        }
      }
    }, _callee62);
  }));
  return _exportParents.apply(this, arguments);
}

function createAcademicYear(_x39, _x40) {
  return _createAcademicYear.apply(this, arguments);
}

function _createAcademicYear() {
  _createAcademicYear = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee63(schoolId, semesters) {
    var response;
    return _regeneratorRuntime.wrap(function _callee63$(_context63) {
      while (1) {
        switch (_context63.prev = _context63.next) {
          case 0:
            _context63.next = 2;
            return http.post("".concat(SCHOOLS_ENDPOINT, "/").concat(schoolId, "/academic-years"), semesters);

          case 2:
            response = _context63.sent;
            return _context63.abrupt("return", response);

          case 4:
          case "end":
            return _context63.stop();
        }
      }
    }, _callee63);
  }));
  return _createAcademicYear.apply(this, arguments);
}

function createCourse(_x41) {
  return _createCourse.apply(this, arguments);
}

function _createCourse() {
  _createCourse = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee64(_ref28) {
    var schoolId, data, response;
    return _regeneratorRuntime.wrap(function _callee64$(_context64) {
      while (1) {
        switch (_context64.prev = _context64.next) {
          case 0:
            schoolId = _ref28.schoolId, data = _ref28.data;
            _context64.next = 3;
            return http.post("".concat(schoolUrl(schoolId), "/courses"), data);

          case 3:
            response = _context64.sent;
            return _context64.abrupt("return", response);

          case 5:
          case "end":
            return _context64.stop();
        }
      }
    }, _callee64);
  }));
  return _createCourse.apply(this, arguments);
}

function uploadThumbnail(_x42) {
  return _uploadThumbnail.apply(this, arguments);
}

function _uploadThumbnail() {
  _uploadThumbnail = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee65(_ref29) {
    var schoolId, data, onUploadProgress, response;
    return _regeneratorRuntime.wrap(function _callee65$(_context65) {
      while (1) {
        switch (_context65.prev = _context65.next) {
          case 0:
            schoolId = _ref29.schoolId, data = _ref29.data, onUploadProgress = _ref29.onUploadProgress;
            _context65.next = 3;
            return http.post("".concat(schoolUrl(schoolId), "/courses/thumbnails"), data, {
              onUploadProgress: onUploadProgress
            });

          case 3:
            response = _context65.sent;
            return _context65.abrupt("return", response);

          case 5:
          case "end":
            return _context65.stop();
        }
      }
    }, _callee65);
  }));
  return _uploadThumbnail.apply(this, arguments);
}

function importCourseTemplates(_x43) {
  return _importCourseTemplates.apply(this, arguments);
}

function _importCourseTemplates() {
  _importCourseTemplates = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee66(_ref30) {
    var schoolId, data, onUploadProgress, response;
    return _regeneratorRuntime.wrap(function _callee66$(_context66) {
      while (1) {
        switch (_context66.prev = _context66.next) {
          case 0:
            schoolId = _ref30.schoolId, data = _ref30.data, onUploadProgress = _ref30.onUploadProgress;
            _context66.next = 3;
            return http.post("".concat(schoolUrl(schoolId), "/course-templates/import"), data, {
              onUploadProgress: onUploadProgress
            });

          case 3:
            response = _context66.sent;
            return _context66.abrupt("return", response);

          case 5:
          case "end":
            return _context66.stop();
        }
      }
    }, _callee66);
  }));
  return _importCourseTemplates.apply(this, arguments);
}

function exportCourseTemplates(_x44) {
  return _exportCourseTemplates.apply(this, arguments);
}

function _exportCourseTemplates() {
  _exportCourseTemplates = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee67(_ref31) {
    var schoolId, response;
    return _regeneratorRuntime.wrap(function _callee67$(_context67) {
      while (1) {
        switch (_context67.prev = _context67.next) {
          case 0:
            schoolId = _ref31.schoolId;
            _context67.next = 3;
            return http.get("".concat(schoolUrl(schoolId), "/course-templates/csv"));

          case 3:
            response = _context67.sent;
            return _context67.abrupt("return", response);

          case 5:
          case "end":
            return _context67.stop();
        }
      }
    }, _callee67);
  }));
  return _exportCourseTemplates.apply(this, arguments);
}

function createCourseTemplate(_x45) {
  return _createCourseTemplate.apply(this, arguments);
}

function _createCourseTemplate() {
  _createCourseTemplate = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee68(_ref32) {
    var schoolId, data, response;
    return _regeneratorRuntime.wrap(function _callee68$(_context68) {
      while (1) {
        switch (_context68.prev = _context68.next) {
          case 0:
            schoolId = _ref32.schoolId, data = _ref32.data;
            _context68.next = 3;
            return http.post("".concat(schoolUrl(schoolId), "/course-templates"), data);

          case 3:
            response = _context68.sent;
            return _context68.abrupt("return", response);

          case 5:
          case "end":
            return _context68.stop();
        }
      }
    }, _callee68);
  }));
  return _createCourseTemplate.apply(this, arguments);
}

function getSchoolsGradebookSystems(_x46) {
  return _getSchoolsGradebookSystems.apply(this, arguments);
}

function _getSchoolsGradebookSystems() {
  _getSchoolsGradebookSystems = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee69(schoolId) {
    var response;
    return _regeneratorRuntime.wrap(function _callee69$(_context69) {
      while (1) {
        switch (_context69.prev = _context69.next) {
          case 0:
            _context69.next = 2;
            return http.get("".concat(schoolUrl(schoolId), "/gradebook-systems"));

          case 2:
            response = _context69.sent;
            return _context69.abrupt("return", response);

          case 4:
          case "end":
            return _context69.stop();
        }
      }
    }, _callee69);
  }));
  return _getSchoolsGradebookSystems.apply(this, arguments);
}

function createSchoolGradebookSystems(_x47, _x48) {
  return _createSchoolGradebookSystems.apply(this, arguments);
}

function _createSchoolGradebookSystems() {
  _createSchoolGradebookSystems = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee70(schoolId, data) {
    var response;
    return _regeneratorRuntime.wrap(function _callee70$(_context70) {
      while (1) {
        switch (_context70.prev = _context70.next) {
          case 0:
            _context70.next = 2;
            return http.post("".concat(schoolUrl(schoolId), "/gradebook-systems"), data);

          case 2:
            response = _context70.sent;
            return _context70.abrupt("return", response);

          case 4:
          case "end":
            return _context70.stop();
        }
      }
    }, _callee70);
  }));
  return _createSchoolGradebookSystems.apply(this, arguments);
}

function getGradeCategories(_x49) {
  return _getGradeCategories.apply(this, arguments);
}

function _getGradeCategories() {
  _getGradeCategories = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee71(schoolId) {
    var response;
    return _regeneratorRuntime.wrap(function _callee71$(_context71) {
      while (1) {
        switch (_context71.prev = _context71.next) {
          case 0:
            _context71.next = 2;
            return http.get("".concat(schoolUrl(schoolId), "/grade-categories"));

          case 2:
            response = _context71.sent;
            return _context71.abrupt("return", response);

          case 4:
          case "end":
            return _context71.stop();
        }
      }
    }, _callee71);
  }));
  return _getGradeCategories.apply(this, arguments);
}

function createGradeCategories(_x50, _x51) {
  return _createGradeCategories.apply(this, arguments);
}

function _createGradeCategories() {
  _createGradeCategories = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee72(schoolId, data) {
    var response;
    return _regeneratorRuntime.wrap(function _callee72$(_context72) {
      while (1) {
        switch (_context72.prev = _context72.next) {
          case 0:
            _context72.next = 2;
            return http.post("".concat(schoolUrl(schoolId), "/grade-categories"), data);

          case 2:
            response = _context72.sent;
            return _context72.abrupt("return", response);

          case 4:
          case "end":
            return _context72.stop();
        }
      }
    }, _callee72);
  }));
  return _createGradeCategories.apply(this, arguments);
}

function addSubject(_x52, _x53) {
  return _addSubject.apply(this, arguments);
}

function _addSubject() {
  _addSubject = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee73(schoolId, baseSubjectId) {
    var response;
    return _regeneratorRuntime.wrap(function _callee73$(_context73) {
      while (1) {
        switch (_context73.prev = _context73.next) {
          case 0:
            _context73.next = 2;
            return http.post("".concat(schoolUrl(schoolId), "/subjects"), {
              baseSubjectId: baseSubjectId
            });

          case 2:
            response = _context73.sent;
            return _context73.abrupt("return", response);

          case 4:
          case "end":
            return _context73.stop();
        }
      }
    }, _callee73);
  }));
  return _addSubject.apply(this, arguments);
}

function createSubject(_x54, _x55) {
  return _createSubject.apply(this, arguments);
}

function _createSubject() {
  _createSubject = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee74(schoolId, name) {
    var response;
    return _regeneratorRuntime.wrap(function _callee74$(_context74) {
      while (1) {
        switch (_context74.prev = _context74.next) {
          case 0:
            _context74.next = 2;
            return http.post("".concat(schoolUrl(schoolId), "/subjects"), {
              name: name
            });

          case 2:
            response = _context74.sent;
            return _context74.abrupt("return", response);

          case 4:
          case "end":
            return _context74.stop();
        }
      }
    }, _callee74);
  }));
  return _createSubject.apply(this, arguments);
}

function activateStages(_x56, _x57) {
  return _activateStages.apply(this, arguments);
}

function _activateStages() {
  _activateStages = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee75(schoolId, stageIds) {
    var response;
    return _regeneratorRuntime.wrap(function _callee75$(_context75) {
      while (1) {
        switch (_context75.prev = _context75.next) {
          case 0:
            _context75.next = 2;
            return http.post("".concat(schoolUrl(schoolId), "/activate-stages"), {
              stageIds: stageIds
            });

          case 2:
            response = _context75.sent;
            return _context75.abrupt("return", response);

          case 4:
          case "end":
            return _context75.stop();
        }
      }
    }, _callee75);
  }));
  return _activateStages.apply(this, arguments);
}

function deactivateStages(_x58, _x59) {
  return _deactivateStages.apply(this, arguments);
}

function _deactivateStages() {
  _deactivateStages = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee76(schoolId, stageIds) {
    var response;
    return _regeneratorRuntime.wrap(function _callee76$(_context76) {
      while (1) {
        switch (_context76.prev = _context76.next) {
          case 0:
            _context76.next = 2;
            return http.post("".concat(schoolUrl(schoolId), "/deactivate-stages"), {
              stageIds: stageIds
            });

          case 2:
            response = _context76.sent;
            return _context76.abrupt("return", response);

          case 4:
          case "end":
            return _context76.stop();
        }
      }
    }, _callee76);
  }));
  return _deactivateStages.apply(this, arguments);
}

function getSchoolCertificate(_x60) {
  return _getSchoolCertificate.apply(this, arguments);
}

function _getSchoolCertificate() {
  _getSchoolCertificate = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee77(_ref33) {
    var schoolId, params, response;
    return _regeneratorRuntime.wrap(function _callee77$(_context77) {
      while (1) {
        switch (_context77.prev = _context77.next) {
          case 0:
            schoolId = _ref33.schoolId, params = _ref33.params;
            _context77.next = 3;
            return http.get("".concat(schoolUrl(schoolId), "/certificates"), {
              params: params
            });

          case 3:
            response = _context77.sent;
            return _context77.abrupt("return", response);

          case 5:
          case "end":
            return _context77.stop();
        }
      }
    }, _callee77);
  }));
  return _getSchoolCertificate.apply(this, arguments);
}

var getCertificateDefaults = /*#__PURE__*/function () {
  var _ref35 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(_ref34) {
    var schoolId, response;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            schoolId = _ref34.schoolId;
            _context.next = 3;
            return http.get("".concat(schoolUrl(schoolId), "/certificate-defaults"));

          case 3:
            response = _context.sent;
            return _context.abrupt("return", response);

          case 5:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function getCertificateDefaults(_x61) {
    return _ref35.apply(this, arguments);
  };
}();

var getSchoolStudentCertificates = /*#__PURE__*/function () {
  var _ref37 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(_ref36) {
    var schoolId, params, response;
    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            schoolId = _ref36.schoolId, params = _ref36.params;
            _context2.next = 3;
            return http.get("".concat(schoolUrl(schoolId), "/student-certificates"), {
              params: params
            });

          case 3:
            response = _context2.sent;
            return _context2.abrupt("return", response);

          case 5:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));

  return function getSchoolStudentCertificates(_x62) {
    return _ref37.apply(this, arguments);
  };
}();

var createPaymentCategory = /*#__PURE__*/function () {
  var _ref39 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(_ref38) {
    var schoolId, data, response;
    return _regeneratorRuntime.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            schoolId = _ref38.schoolId, data = _ref38.data;
            _context3.next = 3;
            return http.post("".concat(schoolUrl(schoolId), "/payment-categories"), data);

          case 3:
            response = _context3.sent;
            return _context3.abrupt("return", response);

          case 5:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3);
  }));

  return function createPaymentCategory(_x63) {
    return _ref39.apply(this, arguments);
  };
}();

var getPaymentCategories = /*#__PURE__*/function () {
  var _ref41 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(_ref40) {
    var schoolId, response;
    return _regeneratorRuntime.wrap(function _callee4$(_context4) {
      while (1) {
        switch (_context4.prev = _context4.next) {
          case 0:
            schoolId = _ref40.schoolId;
            _context4.next = 3;
            return http.get("".concat(schoolUrl(schoolId), "/payment-categories"));

          case 3:
            response = _context4.sent;
            return _context4.abrupt("return", response);

          case 5:
          case "end":
            return _context4.stop();
        }
      }
    }, _callee4);
  }));

  return function getPaymentCategories(_x64) {
    return _ref41.apply(this, arguments);
  };
}();

var updatePaymentSettings = /*#__PURE__*/function () {
  var _ref43 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5(_ref42) {
    var schoolId, data, response;
    return _regeneratorRuntime.wrap(function _callee5$(_context5) {
      while (1) {
        switch (_context5.prev = _context5.next) {
          case 0:
            schoolId = _ref42.schoolId, data = _ref42.data;
            _context5.next = 3;
            return http.put("".concat(constants.API_URL_V1, "/schools/").concat(schoolId, "/payment-settings"), data);

          case 3:
            response = _context5.sent;
            return _context5.abrupt("return", response);

          case 5:
          case "end":
            return _context5.stop();
        }
      }
    }, _callee5);
  }));

  return function updatePaymentSettings(_x65) {
    return _ref43.apply(this, arguments);
  };
}();

var getPaymentSettings = /*#__PURE__*/function () {
  var _ref45 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee6(_ref44) {
    var schoolId, response;
    return _regeneratorRuntime.wrap(function _callee6$(_context6) {
      while (1) {
        switch (_context6.prev = _context6.next) {
          case 0:
            schoolId = _ref44.schoolId;
            _context6.next = 3;
            return http.get("".concat(schoolUrl(schoolId), "/payment-settings"));

          case 3:
            response = _context6.sent;
            return _context6.abrupt("return", response);

          case 5:
          case "end":
            return _context6.stop();
        }
      }
    }, _callee6);
  }));

  return function getPaymentSettings(_x66) {
    return _ref45.apply(this, arguments);
  };
}();

var createPayment = /*#__PURE__*/function () {
  var _ref47 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee7(_ref46) {
    var schoolId, data, response;
    return _regeneratorRuntime.wrap(function _callee7$(_context7) {
      while (1) {
        switch (_context7.prev = _context7.next) {
          case 0:
            schoolId = _ref46.schoolId, data = _ref46.data;
            _context7.next = 3;
            return http.post("".concat(schoolUrl(schoolId), "/payments"), data);

          case 3:
            response = _context7.sent;
            return _context7.abrupt("return", response);

          case 5:
          case "end":
            return _context7.stop();
        }
      }
    }, _callee7);
  }));

  return function createPayment(_x67) {
    return _ref47.apply(this, arguments);
  };
}();

var getSchoolPayments = /*#__PURE__*/function () {
  var _ref49 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee8(_ref48) {
    var schoolId, params, response;
    return _regeneratorRuntime.wrap(function _callee8$(_context8) {
      while (1) {
        switch (_context8.prev = _context8.next) {
          case 0:
            schoolId = _ref48.schoolId, params = _ref48.params;
            _context8.next = 3;
            return http.get("".concat(schoolUrl(schoolId), "/payments"), {
              params: params
            });

          case 3:
            response = _context8.sent;
            return _context8.abrupt("return", response);

          case 5:
          case "end":
            return _context8.stop();
        }
      }
    }, _callee8);
  }));

  return function getSchoolPayments(_x68) {
    return _ref49.apply(this, arguments);
  };
}();

var getPaymentFees = /*#__PURE__*/function () {
  var _ref51 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee9(_ref50) {
    var schoolId, params, response;
    return _regeneratorRuntime.wrap(function _callee9$(_context9) {
      while (1) {
        switch (_context9.prev = _context9.next) {
          case 0:
            schoolId = _ref50.schoolId, params = _ref50.params;
            _context9.next = 3;
            return http.get("".concat(schoolUrl(schoolId), "/paymob-fees"), {
              params: params
            });

          case 3:
            response = _context9.sent;
            return _context9.abrupt("return", response);

          case 5:
          case "end":
            return _context9.stop();
        }
      }
    }, _callee9);
  }));

  return function getPaymentFees(_x69) {
    return _ref51.apply(this, arguments);
  };
}();

var createComplaintType = /*#__PURE__*/function () {
  var _ref53 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee10(_ref52) {
    var schoolId, data, response;
    return _regeneratorRuntime.wrap(function _callee10$(_context10) {
      while (1) {
        switch (_context10.prev = _context10.next) {
          case 0:
            schoolId = _ref52.schoolId, data = _ref52.data;
            _context10.next = 3;
            return http.post("".concat(schoolUrl(schoolId), "/complaint-types"), data);

          case 3:
            response = _context10.sent;
            return _context10.abrupt("return", response);

          case 5:
          case "end":
            return _context10.stop();
        }
      }
    }, _callee10);
  }));

  return function createComplaintType(_x70) {
    return _ref53.apply(this, arguments);
  };
}();

var getComplaintTypes = /*#__PURE__*/function () {
  var _ref55 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee11(_ref54) {
    var schoolId, params, response;
    return _regeneratorRuntime.wrap(function _callee11$(_context11) {
      while (1) {
        switch (_context11.prev = _context11.next) {
          case 0:
            schoolId = _ref54.schoolId, params = _ref54.params;
            _context11.next = 3;
            return http.get("".concat(schoolUrl(schoolId), "/complaint-types"), {
              params: params
            });

          case 3:
            response = _context11.sent;
            return _context11.abrupt("return", response);

          case 5:
          case "end":
            return _context11.stop();
        }
      }
    }, _callee11);
  }));

  return function getComplaintTypes(_x71) {
    return _ref55.apply(this, arguments);
  };
}();

var createComplaint = /*#__PURE__*/function () {
  var _ref57 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee12(_ref56) {
    var schoolId, data, response;
    return _regeneratorRuntime.wrap(function _callee12$(_context12) {
      while (1) {
        switch (_context12.prev = _context12.next) {
          case 0:
            schoolId = _ref56.schoolId, data = _ref56.data;
            _context12.next = 3;
            return http.post("".concat(schoolUrl(schoolId), "/complaints"), data);

          case 3:
            response = _context12.sent;
            return _context12.abrupt("return", response);

          case 5:
          case "end":
            return _context12.stop();
        }
      }
    }, _callee12);
  }));

  return function createComplaint(_x72) {
    return _ref57.apply(this, arguments);
  };
}();

var getSchoolComplaints = /*#__PURE__*/function () {
  var _ref59 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee13(_ref58) {
    var schoolId, params, response;
    return _regeneratorRuntime.wrap(function _callee13$(_context13) {
      while (1) {
        switch (_context13.prev = _context13.next) {
          case 0:
            schoolId = _ref58.schoolId, params = _ref58.params;
            _context13.next = 3;
            return http.get("".concat(schoolUrl(schoolId), "/complaints"), {
              params: params
            });

          case 3:
            response = _context13.sent;
            return _context13.abrupt("return", response);

          case 5:
          case "end":
            return _context13.stop();
        }
      }
    }, _callee13);
  }));

  return function getSchoolComplaints(_x73) {
    return _ref59.apply(this, arguments);
  };
}();

var getExportSchoolComplaints = /*#__PURE__*/function () {
  var _ref61 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee14(_ref60) {
    var schoolId, params, onDownloadProgress, response;
    return _regeneratorRuntime.wrap(function _callee14$(_context14) {
      while (1) {
        switch (_context14.prev = _context14.next) {
          case 0:
            schoolId = _ref60.schoolId, params = _ref60.params, onDownloadProgress = _ref60.onDownloadProgress;
            _context14.next = 3;
            return http.get("".concat(schoolUrl(schoolId), "/complaints/csv"), {
              params: params,
              onDownloadProgress: onDownloadProgress
            });

          case 3:
            response = _context14.sent;
            return _context14.abrupt("return", response);

          case 5:
          case "end":
            return _context14.stop();
        }
      }
    }, _callee14);
  }));

  return function getExportSchoolComplaints(_x74) {
    return _ref61.apply(this, arguments);
  };
}();

var getSchoolDismissals = /*#__PURE__*/function () {
  var _ref63 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee15(_ref62) {
    var schoolId, params, response;
    return _regeneratorRuntime.wrap(function _callee15$(_context15) {
      while (1) {
        switch (_context15.prev = _context15.next) {
          case 0:
            schoolId = _ref62.schoolId, params = _ref62.params;
            _context15.next = 3;
            return http.get("".concat(schoolUrl(schoolId), "/dismissals"), {
              params: params
            });

          case 3:
            response = _context15.sent;
            return _context15.abrupt("return", response);

          case 5:
          case "end":
            return _context15.stop();
        }
      }
    }, _callee15);
  }));

  return function getSchoolDismissals(_x75) {
    return _ref63.apply(this, arguments);
  };
}();

var getSchoolDismissalSettings = /*#__PURE__*/function () {
  var _ref65 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee16(_ref64) {
    var schoolId, response;
    return _regeneratorRuntime.wrap(function _callee16$(_context16) {
      while (1) {
        switch (_context16.prev = _context16.next) {
          case 0:
            schoolId = _ref64.schoolId;
            _context16.next = 3;
            return http.get("".concat(schoolUrl(schoolId), "/dismissal-settings"));

          case 3:
            response = _context16.sent;
            return _context16.abrupt("return", response);

          case 5:
          case "end":
            return _context16.stop();
        }
      }
    }, _callee16);
  }));

  return function getSchoolDismissalSettings(_x76) {
    return _ref65.apply(this, arguments);
  };
}();

var updateDismissalSettings = /*#__PURE__*/function () {
  var _ref67 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee17(_ref66) {
    var schoolId, data, response;
    return _regeneratorRuntime.wrap(function _callee17$(_context17) {
      while (1) {
        switch (_context17.prev = _context17.next) {
          case 0:
            schoolId = _ref66.schoolId, data = _ref66.data;
            _context17.next = 3;
            return http.put("".concat(constants.API_URL, "/schools/").concat(schoolId, "/dismissal-settings"), data);

          case 3:
            response = _context17.sent;
            return _context17.abrupt("return", response);

          case 5:
          case "end":
            return _context17.stop();
        }
      }
    }, _callee17);
  }));

  return function updateDismissalSettings(_x77) {
    return _ref67.apply(this, arguments);
  };
}();

var dismissalCall = /*#__PURE__*/function () {
  var _ref69 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee18(_ref68) {
    var schoolId, data, response;
    return _regeneratorRuntime.wrap(function _callee18$(_context18) {
      while (1) {
        switch (_context18.prev = _context18.next) {
          case 0:
            schoolId = _ref68.schoolId, data = _ref68.data;
            _context18.next = 3;
            return http.post("".concat(schoolUrl(schoolId), "/dismissal-call"), data);

          case 3:
            response = _context18.sent;
            return _context18.abrupt("return", response);

          case 5:
          case "end":
            return _context18.stop();
        }
      }
    }, _callee18);
  }));

  return function dismissalCall(_x78) {
    return _ref69.apply(this, arguments);
  };
}();

var deleteDigitalIdentity = /*#__PURE__*/function () {
  var _ref71 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee19(_ref70) {
    var schoolId, userId, response;
    return _regeneratorRuntime.wrap(function _callee19$(_context19) {
      while (1) {
        switch (_context19.prev = _context19.next) {
          case 0:
            schoolId = _ref70.schoolId, userId = _ref70.userId;
            _context19.next = 3;
            return http["delete"]("".concat(schoolUrl(schoolId), "/users/").concat(userId, "/digital-identity"));

          case 3:
            response = _context19.sent;
            return _context19.abrupt("return", response);

          case 5:
          case "end":
            return _context19.stop();
        }
      }
    }, _callee19);
  }));

  return function deleteDigitalIdentity(_x79) {
    return _ref71.apply(this, arguments);
  };
}();

var addDigitalId = /*#__PURE__*/function () {
  var _ref73 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee20(_ref72) {
    var schoolId, sendToParent, data, response;
    return _regeneratorRuntime.wrap(function _callee20$(_context20) {
      while (1) {
        switch (_context20.prev = _context20.next) {
          case 0:
            schoolId = _ref72.schoolId, sendToParent = _ref72.sendToParent, data = _ref72.data;
            _context20.next = 3;
            return http.post("".concat(schoolUrl(schoolId), "/digital-identities"), data, {
              params: {
                sendToParent: sendToParent
              }
            });

          case 3:
            response = _context20.sent;
            return _context20.abrupt("return", response);

          case 5:
          case "end":
            return _context20.stop();
        }
      }
    }, _callee20);
  }));

  return function addDigitalId(_x80) {
    return _ref73.apply(this, arguments);
  };
}();

var callDismissal = /*#__PURE__*/function () {
  var _ref75 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee21(_ref74) {
    var schoolId, data, response;
    return _regeneratorRuntime.wrap(function _callee21$(_context21) {
      while (1) {
        switch (_context21.prev = _context21.next) {
          case 0:
            schoolId = _ref74.schoolId, data = _ref74.data;
            _context21.next = 3;
            return http.post("".concat(schoolUrl(schoolId), "/dismissal-call"), data);

          case 3:
            response = _context21.sent;
            return _context21.abrupt("return", response);

          case 5:
          case "end":
            return _context21.stop();
        }
      }
    }, _callee21);
  }));

  return function callDismissal(_x81) {
    return _ref75.apply(this, arguments);
  };
}();

var getDigitalIdentities = /*#__PURE__*/function () {
  var _ref77 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee22(_ref76) {
    var schoolId, params, response;
    return _regeneratorRuntime.wrap(function _callee22$(_context22) {
      while (1) {
        switch (_context22.prev = _context22.next) {
          case 0:
            schoolId = _ref76.schoolId, params = _ref76.params;
            _context22.next = 3;
            return http.get("".concat(schoolUrl(schoolId), "/digital-identities"), {
              params: params
            });

          case 3:
            response = _context22.sent;
            return _context22.abrupt("return", response);

          case 5:
          case "end":
            return _context22.stop();
        }
      }
    }, _callee22);
  }));

  return function getDigitalIdentities(_x82) {
    return _ref77.apply(this, arguments);
  };
}();

var sendDigitalIdentities = /*#__PURE__*/function () {
  var _ref79 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee23(_ref78) {
    var schoolId, data, response;
    return _regeneratorRuntime.wrap(function _callee23$(_context23) {
      while (1) {
        switch (_context23.prev = _context23.next) {
          case 0:
            schoolId = _ref78.schoolId, data = _ref78.data;
            _context23.next = 3;
            return http.post("".concat(schoolUrl(schoolId), "/digital-identities/messages"), data);

          case 3:
            response = _context23.sent;
            return _context23.abrupt("return", response);

          case 5:
          case "end":
            return _context23.stop();
        }
      }
    }, _callee23);
  }));

  return function sendDigitalIdentities(_x83) {
    return _ref79.apply(this, arguments);
  };
}();

var copyStageMessageSettings = /*#__PURE__*/function () {
  var _ref81 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee24(_ref80) {
    var schoolId, stageId, data, response;
    return _regeneratorRuntime.wrap(function _callee24$(_context24) {
      while (1) {
        switch (_context24.prev = _context24.next) {
          case 0:
            schoolId = _ref80.schoolId, stageId = _ref80.stageId, data = _ref80.data;
            _context24.next = 3;
            return http.post("".concat(schoolUrl(schoolId), "/stages/").concat(stageId, "/messages/settings"), data);

          case 3:
            response = _context24.sent;
            return _context24.abrupt("return", response);

          case 5:
          case "end":
            return _context24.stop();
        }
      }
    }, _callee24);
  }));

  return function copyStageMessageSettings(_x84) {
    return _ref81.apply(this, arguments);
  };
}();

var updateStageMessageSettings = /*#__PURE__*/function () {
  var _ref83 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee25(_ref82) {
    var schoolId, stageId, data, response;
    return _regeneratorRuntime.wrap(function _callee25$(_context25) {
      while (1) {
        switch (_context25.prev = _context25.next) {
          case 0:
            schoolId = _ref82.schoolId, stageId = _ref82.stageId, data = _ref82.data;
            _context25.next = 3;
            return http.patch("".concat(schoolUrl(schoolId), "/stages/").concat(stageId, "/messages/settings"), data);

          case 3:
            response = _context25.sent;
            return _context25.abrupt("return", response);

          case 5:
          case "end":
            return _context25.stop();
        }
      }
    }, _callee25);
  }));

  return function updateStageMessageSettings(_x85) {
    return _ref83.apply(this, arguments);
  };
}();

var getSchoolMessageSettings = /*#__PURE__*/function () {
  var _ref85 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee26(_ref84) {
    var schoolId, response;
    return _regeneratorRuntime.wrap(function _callee26$(_context26) {
      while (1) {
        switch (_context26.prev = _context26.next) {
          case 0:
            schoolId = _ref84.schoolId;
            _context26.next = 3;
            return http.get("".concat(schoolUrl(schoolId), "/messages/settings"));

          case 3:
            response = _context26.sent;
            return _context26.abrupt("return", response);

          case 5:
          case "end":
            return _context26.stop();
        }
      }
    }, _callee26);
  }));

  return function getSchoolMessageSettings(_x86) {
    return _ref85.apply(this, arguments);
  };
}();

var updateSchoolMessageSettings = /*#__PURE__*/function () {
  var _ref87 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee27(_ref86) {
    var schoolId, data, response;
    return _regeneratorRuntime.wrap(function _callee27$(_context27) {
      while (1) {
        switch (_context27.prev = _context27.next) {
          case 0:
            schoolId = _ref86.schoolId, data = _ref86.data;
            _context27.next = 3;
            return http.post("".concat(schoolUrl(schoolId), "/messages/settings"), data);

          case 3:
            response = _context27.sent;
            return _context27.abrupt("return", response);

          case 5:
          case "end":
            return _context27.stop();
        }
      }
    }, _callee27);
  }));

  return function updateSchoolMessageSettings(_x87) {
    return _ref87.apply(this, arguments);
  };
}();

export default {
  getSchools: getSchools,
  deleteAdmin: deleteAdmin,
  createAdmin: createAdmin,
  createPrincipal: createPrincipal,
  createHod: createHod,
  createParent: createParent,
  getSchoolSystems: getSchoolSystems,
  getSchoolGradebookSystems: getSchoolGradebookSystems,
  deactivateSchool: deactivateSchool,
  deleteSchool: deleteSchool,
  updateSchool: updateSchool,
  createSchool: createSchool,
  getSchool: getSchool,
  createAnnouncement: createAnnouncement,
  listSchoolAnnouncements: listSchoolAnnouncements,
  getSchoolQuestions: getSchoolQuestions,
  getSchoolCourseTemplates: getSchoolCourseTemplates,
  getSchoolTags: getSchoolTags,
  createTag: createTag,
  getSchoolSemesters: getSchoolSemesters,
  getActiveSemester: getActiveSemester,
  createTeacher: createTeacher,
  importTeachers: importTeachers,
  exportTeachers: exportTeachers,
  createStudent: createStudent,
  importPerformanceComments: importPerformanceComments,
  exportPerformanceComments: exportPerformanceComments,
  importParents: importParents,
  exportParents: exportParents,
  exportScores: exportScores,
  createAcademicYear: createAcademicYear,
  createCourse: createCourse,
  uploadThumbnail: uploadThumbnail,
  importCourseTemplates: importCourseTemplates,
  exportCourseTemplates: exportCourseTemplates,
  createCourseTemplate: createCourseTemplate,
  getSchoolsGradebookSystems: getSchoolsGradebookSystems,
  createSchoolGradebookSystems: createSchoolGradebookSystems,
  getGradeCategories: getGradeCategories,
  createGradeCategories: createGradeCategories,
  addSubject: addSubject,
  createSubject: createSubject,
  activateStages: activateStages,
  deactivateStages: deactivateStages,
  getSchoolCertificate: getSchoolCertificate,
  getCertificateDefaults: getCertificateDefaults,
  getSchoolStudentCertificates: getSchoolStudentCertificates,
  createPaymentCategory: createPaymentCategory,
  getPaymentCategories: getPaymentCategories,
  updatePaymentSettings: updatePaymentSettings,
  getPaymentSettings: getPaymentSettings,
  createPayment: createPayment,
  getSchoolPayments: getSchoolPayments,
  getPaymentFees: getPaymentFees,
  createComplaintType: createComplaintType,
  getComplaintTypes: getComplaintTypes,
  createComplaint: createComplaint,
  getSchoolComplaints: getSchoolComplaints,
  getExportSchoolComplaints: getExportSchoolComplaints,
  getSchoolDismissals: getSchoolDismissals,
  getSchoolDismissalSettings: getSchoolDismissalSettings,
  updateDismissalSettings: updateDismissalSettings,
  dismissalCall: dismissalCall,
  deleteDigitalIdentity: deleteDigitalIdentity,
  addDigitalId: addDigitalId,
  callDismissal: callDismissal,
  getDigitalIdentities: getDigitalIdentities,
  sendDigitalIdentities: sendDigitalIdentities,
  copyStageMessageSettings: copyStageMessageSettings,
  updateStageMessageSettings: updateStageMessageSettings,
  getSchoolMessageSettings: getSchoolMessageSettings,
  updateSchoolMessageSettings: updateSchoolMessageSettings,
  getSchoolParentsV1: getSchoolParentsV1,
  getSchoolStudentsV1: getSchoolStudentsV1,
  getSchoolTeachersV1: getSchoolTeachersV1,
  getSchoolPrincipalsV2: getSchoolPrincipalsV2,
  getSchoolHodsV2: getSchoolHodsV2
};